"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.omitDataTestProps = exports.omitDataProps = void 0;
/**
 * Filter props to get without data-* or data[A-Z]* props
 *
 * @param {*} allProps props to filter
 */
const omitDataProps = allProps => Object.keys(allProps).filter(key => !key.match(/^data-|^data[A-Z]/)).reduce((out, key) => ({
  ...out,
  [key]: allProps[key]
}), {});

/**
 * Filter props to get without data-test* or dataTest[A-Z]* props
 *
 * @param {*} allProps props to filter
 */
exports.omitDataProps = omitDataProps;
const omitDataTestProps = allProps => Object.keys(allProps).filter(key => !key.match(/^data-test-|^dataTest[A-Z]/)).reduce((out, key) => ({
  ...out,
  [key]: allProps[key]
}), {});
exports.omitDataTestProps = omitDataTestProps;